import {httpAction, getAction, postAction} from '@/api/manage'
//取消
export function cancel(that,record){
  /*if(applicationCode === 'env_audit'){
    epm_cancel(that,record);
  }else if(applicationCode === 'ipsys'){
    ipsys_cancel(that,record)
  }*/
  that.$refs.commentsModal.edit({title:that.language['eletronicSigned.termination'],type:"Cancel",businessFormNo:record.businessFormNo});
}
function epm_cancel(that,record) {
  let map = {}
  map.pfBpmProcessId = record.processGuid;
  map.workNo = that.$store.getters.userInfo.workNo;
  map.approveAction = "Cancel";
  // map.taskCode = record.readyTask.taskGuid;
  map.url="/sys/electronicSigned/envProcess/"+record.processGuid
  map.httptype="Post"
  map.title = that.language['eletronicSigned.termination'];
  that.$refs.myTodoCommentsModal.edit(map);
}
function ipsys_cancel(that,record) {
  let map = {}
  map.processGuid = record.process_guid;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.approveAction = "Cancel";
  map.taskCode = record.task_code;
  map.url="/sys/electronicSigned/ipsysProcess/"+record.process_guid
  map.httptype="Post"
  map.title = that.language['eletronicSigned.termination'];
  that.$refs.myTodoCommentsModal.edit(map);
}